import DynamicLink from 'components/DynamicLink';
import RenderInfo from 'components/RenderInfo';
import React from 'react';
import styles from './index.module.scss';

const BasicDetails = (props) => {
  const { details } = props;

  return <div className={styles['shopping-list-details-section']}>
    <div className={styles['shopping-list-info']}>
      <div className={styles['info']}>
        <RenderInfo heading="Shopping List ID" value={details.objectId} />
        <RenderInfo heading="Name" value={details.name} />
        <RenderInfo heading="Push to cart count" value={details?.pushToCartCount} defaultValue={0} />
        <DynamicLink link={details?.dynamicLink}/>
      </div>
      <div className={styles['info']}>
        <RenderInfo heading="Public" value={details?.isPublic} type='boolean' />
        <RenderInfo heading="Featured" value={details?.isFeatured} type='boolean' />
        <RenderInfo heading="Purchase count" value={details?.purchaseCount} defaultValue={0} />
      </div>
    </div>
  </div>;
};

export default BasicDetails;